module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/target-256a87c7e8ac11c803bc727c249dac7f.svg";